import { isNil } from 'lodash'
import type { CountryCode } from './debtorModels'
import { isEmptyString } from '@/shared/utils/stringUtils'

export type Address = {
    first: string
    second?: string
    city: string
    region?: string
    postal: string
    country: CountryCode
}

// The backend `OutputAddressSchema` sends null for a missing second line or region.
export type OutputAddress = Omit<Address, 'second' | 'region'> & { second?: string | null; region?: string | null }

export function sanitizeAddress(address: OutputAddress | undefined | null): Address | undefined {
    if (
        isNil(address) ||
        (isEmptyString(address.country) &&
            isEmptyString(address.city) &&
            isEmptyString(address.first) &&
            isEmptyString(address.postal))
    )
        return undefined

    return {
        first: address.first.trim(),
        city: address.city.trim(),
        postal: address.postal.trim(),
        // eslint-disable-next-line typescript/no-unsafe-type-assertion -- the value comes from the option list this field offers, as it always has
        country: address.country.trim() as CountryCode,
        second: address.second?.trim() || undefined,
        region: address.region?.trim() || undefined
    }
}
